import { render, staticRenderFns } from "./FormGroups.vue?vue&type=template&id=d199b656"
import script from "./FormGroups.vue?vue&type=script&lang=js"
export * from "./FormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports